package ai.flowstorm.studio.ui.builder

import ai.flowstorm.common.ui.Form
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.studio.ui.form.EntityId
import ai.flowstorm.studio.ui.form.UserId
import io.kvision.form.text.Text
import io.kvision.i18n.tr

class BuildRequestForm : Form<BuildRequest>(BuildRequest.serializer()) {

    init {
        marginTop = UiHelpers.spacing
        marginRight = UiHelpers.spacing
        add(
            BuildRequest::name, Text(label = tr("Name"))
        )
        add(
            BuildRequest::description, Text(label = tr("Description"))
        )
        add(
            BuildRequest::dialoguesCountString, Text(label = tr("Dialogue Count"))
        )
    }

    fun load(buildRequest: BuildRequest): BuildRequestForm {
        if (buildRequest.state != RequestState.Stopped) {
            disableAll()
        } else {
            enableAll()
        }
        form.fields[BuildRequest::dialoguesCountString.name]!!.disabled = true
        setData(buildRequest)
        return this
    }
}
